import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class Progress extends Component {
    constructor(props) {
        super(props);
        this.goToStep = this.goToStep.bind(this)
    }

    render() {
        return <div className="col-12 progress-container">
            <ul className="progressbar">
                <a data-step={0} onClick={this.goToStep}>
                    <li className={'active'}>{this.props.t('Ervaring')}</li>
                </a>
                <a data-step={1} onClick={this.goToStep}>
                    <li className={this.props.step > 0 ? 'active' : undefined}>{this.props.t('Gebruik')}</li>
                </a>
                <a data-step={2} onClick={this.goToStep}>
                    <li className={this.props.step > 1 ? 'active' : undefined}>{this.props.t('Persoonlijke gegevens')}</li>
                </a>
                <a data-step={3} onClick={this.goToStep}>
                    <li className={this.props.step > 2 ? 'active' : undefined}>{this.props.t('Prijsvoorkeur')}</li>
                </a>
                <a data-step={4} onClick={this.goToStep}>
                    <li className={this.props.step > 3 ? 'active' : undefined}>{this.props.t('Advies')}</li>
                </a>
            </ul>
        </div>
    }
    goToStep(event) {
        let step = parseInt(event.target.closest('a').dataset.step, 10);
        if(step < this.props.step) {
            switch (step) {
                case 0:
                    this.props.goTo('/advice/experience', this.props.traject);
                    break;
                case 1:
                    this.props.goTo('/advice/parcour_type', this.props.traject);
                    break;
                case 2:
                    this.props.goTo('/advice/gender', this.props.traject);
                    break;
                case 3:
                    this.props.goTo('/advice/price', this.props.traject);
                    break;
                default:
                    console.log('trying to go to step ' + step + ' while on step ' + this.props.step);
            }
        }
    }
}

export default withTranslation('progress')(Progress);